import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { type RepoFilterParams } from '@webapp/infrastructure/interfaces/repositories/RepoFilterParams'
import { pdfLabelSetRepository } from '../data-access/repositories/PDFLabelSetRepository'

const base = ['vendor', 'pdf-label-set']

export const pdfLabelSetQueryConfig = {
  all: () => ({
    queryKey: buildQueryKey(base),
  }),
  list: (params?: RepoFilterParams) => ({
    queryKey: buildQueryKey([...base, 'list', params]),
    queryFn: () => pdfLabelSetRepository.list(params),
  }),
  detail: (key: string) => ({
    queryKey: buildQueryKey([...base, 'detail', key]),
    queryFn: () => pdfLabelSetRepository.get(key),
  }),
  primary: () => ({
    queryKey: buildQueryKey([...base, 'primary']),
    queryFn: () => pdfLabelSetRepository.getPrimary(),
  }),
  fieldMetadata: () => ({
    queryKey: buildQueryKey([...base, 'field-metadata']),
    queryFn: () => pdfLabelSetRepository.getFieldMetadata(),
  }),
}
